import { getCustomProps } from '../forms'
import { getData } from '../get-table'
import { HttpService } from '../http.service'

const http = new HttpService()

export interface Department {
  code: string
  name: string
  costCenterId: string
  managementId: string
}

export async function getDepartments(
  offset: number,
  perPage: number,
  dataOrder: string,
  search: string = ''
): Promise<any> {
  // where's
  const where = ['directions.company_id=:companyId']
  if (search) {
    where.push(
      `CONCAT(departments.name,departments.code,managements.name,managements.code,directions.name,directions.code) ILIKE '%${search}%'`
    )
  }
  // order by
  let modifier = []
  dataOrder !== ''
    ? dataOrder[1] === 'code'
      ? (modifier = [
          `ORDER BY (CASE WHEN departments.code ~ '^[0-9]+$' THEN CAST(departments.code AS NUMERIC) ELSE NULL END) ${dataOrder[0]}, departments.code ${dataOrder[0]}`
        ])
      : (modifier = [`order by ${dataOrder[1]} ${dataOrder[0]}`])
    : (modifier = [
        "ORDER BY (CASE WHEN departments.code ~ '^[0-9]+$' THEN CAST(departments.code AS NUMERIC) ELSE NULL END), departments.code"
      ])
  // result
  const response: any = await getData({
    tables: ['pg_departments'],
    fields: [
      'departments.id',
      'departments.code',
      'departments.name',
      "CONCAT(directions.code,' - ',directions.name) as direction",
      "CONCAT(managements.code,' - ',managements.name) as management",
      'departments.is_inactive',
      'departments.updated_at'
    ],
    join: [
      'INNER JOIN managements ON departments.management_id = managements.id',
      'INNER JOIN directions ON directions.id=managements.direction_id',
      'INNER JOIN companies ON companies.id=directions.company_id'
    ],
    where,
    modifier,
    options: {
      outputFormat: 'json',
      pagination: { offset, limit: perPage }
    }
  })
  return response
}

export async function getDepartment(id: string): Promise<Department> {
  const data = await getData<any>({
    tables: ['pg_departments'],
    join: [
      'INNER JOIN managements ON  managements.id = departments.management_id'
    ],
    fields: [
      'departments.id',
      'departments.name',
      'departments.code',
      'departments.management_id as managementId',
      'managements.direction_id as directionId',
      'departments.cost_center_id as costCenterId',
      'departments.is_inactive',
      'departments.custom_fields as custom'
    ],
    where: [`departments.id = '${id}'`],
    options: {
      outputFormat: 'json',
      pagination: { offset: 0, limit: 10 }
    }
  })
  return data[0].results[0]
}

export async function createDepartment(data: Department): Promise<boolean> {
  const response: any = await http.post('payroll/departments', {
    name: data.name,
    code: data.code,
    costCenterId: data.costCenterId,
    managementId: data.managementId,
    customFields: {
      ...getCustomProps(data)
    }
  })

  if (response?.data?.data?.error) {
    return false
  }
  return true
}

export async function updateDepartment(
  data: Department,
  id: string
): Promise<boolean> {
  const response: any = await http.put('payroll/departments/' + id, {
    name: data.name,
    code: data.code,
    costCenterId: data.costCenterId,
    managementId: data.managementId,
    customFields: {
      ...getCustomProps(data)
    }
  })

  if (response?.data?.data?.error) {
    return false
  }
  return true
}

export async function updateStateDepartment(
  id: string,
  enable: boolean
): Promise<boolean> {
  const response: any = await http.put(`payroll/departments/${id}/enable/`, {
    enable
  })

  if (response?.data?.data?.error) {
    return false
  }
  return true
}

export async function deleteDepartment(id: string): Promise<boolean> {
  const response: any = await http.delete('payroll/departments/' + id)

  if (response?.data?.data?.error) {
    return false
  }
  return true
}
